<div class="loader" *ngIf="loader_service.loading"></div>
<div class="loader" *ngIf="loader_service.product_loading"></div>

<div class="loader main_loader" *ngIf="loader_service.main_loading"></div>
<router-outlet></router-outlet>
